export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const AUTHORIZE_USER = 'AUTHORIZE_USER';

export const SET_BOOKING = 'SET_BOOKING';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_BALANCE = 'SET_USER_BALANCE';

export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_LEVELS = 'SET_LEVELS';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_WORDS_CATEGORIES = 'SET_WORDS_CATEGORIES';
export const SET_WORDS_DESCRIPTION = 'SET_WORDS_DESCRIPTION';
export const SET_QUICK_PHRASES = 'SET_QUICK_PHRASES';
export const SET_LOADING_DESCRIPTION = 'SET_LOADING_DESCRIPTION';
export const SET_CHARGING = 'SET_CHARGING';
export const SET_QUESTIONS = 'SET_QUESTIONS';
export const SET_QUESTIONS_DETAIL = 'SET_QUESTIONS_DETAIL';
export const SET_QUESTION_DETAIL_LOAD = 'SET_QUESTION_DETAIL_LOAD';
export const SET_TOPIC_CATEGORIES = 'SET_TOPIC_CATEGORIES';
export const SET_TOPICS = 'SET_TOPICS';

export const SET_REQUEST = 'SET_REQUEST';
export const REMOVE_REQUEST = 'REMOVE_REQUEST';

export const SET_LESSONS = 'SET_LESSONS';
export const SET_LESSON = 'SET_LESSON';
export const FINISH_LESSON = 'FINISH_LESSON';

export const SET_CHAT = 'SET_CHAT';
export const SET_CURRENT_CHAT_ID = 'SET_CURRENT_CHAT_ID';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_MESSAGE_MARK = 'SET_MESSAGE_MARK';

export const SET_PROOFREAD_LANGUAGES = 'SET_PROOFREAD_LANGUAGES';
export const SET_PROOFREADS = 'SET_PROOFREADS';
export const SET_HISTORY_PROOFREADS = 'SET_HISTORY_PROOFREADS';
// export const SET_PROOFREAD = 'SET_PROOFREAD';
export const SET_CURRENT_TASK = 'SET_CURRENT_TASK';
